import(/* webpackMode: "eager" */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["SafeImage"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/common/SafeImage.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["FigmaHeroSection"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/figma-home/FigmaHeroSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeDeferredSections"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/figma-home/HomeDeferredSections.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileStickyFinder"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/figma-home/MobileStickyFinder.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/layout/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/layout/Header.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["IdleMount"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/layout/IdleMount.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/layout/MobileBottomNav.jsx");
